import { api } from "./index";

export const getAllStands = () => {
  return new Promise((resolve, reject) => {
    api
      .get("stands")
      .then(({ data }) => {
        resolve(data);
      })
      .catch(({ response: { data } }) => reject(data));
  });
};

export const getStand = (id) => {
  return new Promise((resolve, reject) => {
    api
      .get(`stands/${id}`)
      .then(({ data }) => {
        resolve(data);
      })
      .catch(({ response: { data } }) => reject(data));
  });
};

export const updateStand = (id, formData) => {
  formData.append("_method", "PUT");
  return new Promise((resolve, reject) => {
    api
      .post(`stands/${id}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then(({ data }) => {
        resolve(data);
      })
      .catch(({ response: { data } }) => reject(data));
  });
};

export const emptyStand = (id) => {
  return new Promise((resolve, reject) => {
    api
      .put(`stands/${id}/empty`)
      .then(({ data }) => {
        resolve(data);
      })
      .catch(({ response: { data } }) => reject(data));
  });
};
